import { useEffect, useRef, useState } from 'react';

interface Props {
  siteKey: string;
  enabled: boolean;
  onToken: (token: string) => void;
}

declare global {
  interface Window {
    turnstile?: {
      render: (el: HTMLElement, opts: { sitekey: string; callback: (token: string) => void; theme?: string; action?: string }) => string;
      remove?: (id: string) => void;
    };
  }
}

export function TurnstileBox({ siteKey, enabled, onToken }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState(enabled ? 'waiting for human check' : 'developer bypass: Turnstile site key not configured');

  useEffect(() => {
    if (!enabled) {
      onToken('dev-bypass');
      return;
    }
    const scriptId = 'cf-turnstile-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    let widgetId = '';
    const timer = window.setInterval(() => {
      if (window.turnstile && ref.current && !widgetId) {
        widgetId = window.turnstile.render(ref.current, {
          sitekey: siteKey,
          theme: 'dark',
          action: 'start-driftglass',
          callback: (token) => {
            setStatus('human check complete');
            onToken(token);
          }
        });
        window.clearInterval(timer);
      }
    }, 120);

    return () => {
      window.clearInterval(timer);
      if (widgetId && window.turnstile?.remove) window.turnstile.remove(widgetId);
    };
  }, [enabled, onToken, siteKey]);

  return (
    <div className="turnstile-box">
      <div ref={ref} />
      <small>{status}</small>
    </div>
  );
}
